// extracted by mini-css-extract-plugin
module.exports = {"main":"root_main__2986Z"};